import classNames from 'classnames';
import styles from './styles.module.scss';
import { FC, HTMLAttributes, memo, ReactNode } from 'react';

export interface TFragmentsButtonProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
  onClick: VoidFunction;
  children?: ReactNode;
  icon?: string;
  color: 'yellow'
}

const FragmentsButton: FC<TFragmentsButtonProps> = memo(({ onClick, className, children, icon, color, ...rest }) => {
  return (
    <button {...rest} className={classNames(styles.fragmentsButton, styles[color], className)} onClick={onClick} type="button">
      <div className={styles.background} />
      {icon && <div className={classNames(`ui-icon-${icon}`, 'icon')} />}
      {children}
    </button>
  );
});

export default FragmentsButton;
